export const DAYS = ['All', '1', '2-3', '4-5', '6-8', '9-14', '15-21'];
export const ALLDAYS = {
    '1': [1],
    '2-3': [2,3],
    '4-5': [4,5],
    '6-8': [6,7,8],
    '9-14': [9,10,11,12,13,14],
    '15-21': [15,16,17,18,19,20,21]
};